import "core-js/modules/web.dom.iterable";
import _regeneratorRuntime from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.regexp.replace";
/**
 * 接口URL文档
 * 刘松
 */
import request from "./request"; // 引入axios的封装方法
import axios from 'axios';
import qs from 'qs';
var rptApi = '/rptApi/v1';
import { Message } from 'element-ui';
import requestPro from "./requestPro";
import store from "../store/index";
/* -------------------------------- 套餐 ------------------------------ */
// 查询所有套餐标签
export var getPackageLabels = function getPackageLabels(params) {
  return request('get', '/api/crm/web/tags/', params);
};
// 查询套餐详细信息
export var getPackageDetailInfo = function getPackageDetailInfo(params) {
  return request('get', '/api/crm/web/offers/' + params);
};
// 查询套餐列表
export var getPackageList = function getPackageList(params) {
  return request('post', '/api/crm/web/offers/query', params);
};
// 查询套餐列表(取消一人一策一区一策限制)
export var queryOfferByCheck = function queryOfferByCheck(params) {
  return request('post', '/api/crm/web/offers/queryOfferByCheck', params);
};
// 查询全部套餐信息（包括不在售卖的）
export var queryOfferAll = function queryOfferAll(params) {
  return request('post', '/api/crm/web/offers/queryOfferAll', params);
};
// 修改组合套餐的下架时间
export var updateOffer = function updateOffer(params) {
  return request('post', '/api/crm/web/offers/updateOffer', params);
};
// 计算套餐时长
export var calExpireDate = function calExpireDate(params) {
  return request('get', '/api/crm/web/offers/calExpireDate', params);
};
// 通过用户id查询已经订购套餐信息
export var queryInsOfferByUserId = function queryInsOfferByUserId(query) {
  if (query.userId) {
    return request('get', '/api/crm/web/insOffer/queryInsOfferByUserId', query);
  } else {
    Message({
      type: 'error',
      message: 'userId不可为空'
    });
    return Promise.reject('userId为空');
  }
};
// 通过产品实例id查询指定日期所在的权责日
export var queryBillingDayByInsProdId = function queryBillingDayByInsProdId(params) {
  return request('get', '/api/crm/web/insOffer/queryBillingDayByInsProd', params);
};
// 查询组合套餐
export var getComposePackage = function getComposePackage(offerId) {
  return request('get', "/api/crm/web/offers/rel/".concat(offerId));
};
// 查询组合套餐
export var getComposePackageApi = function getComposePackageApi(offerId) {
  return request('get', "/api/crm/web/offers/".concat(offerId));
};
// 添加自定义组合套餐
export var saveOffer = function saveOffer(params) {
  return request('post', "/api/crm/web/offers/saveOffer", params);
};
// 删除套餐
export var deleteOffer = function deleteOffer(params) {
  return request('post', "/api/crm/web/offers/deleteOffer", params);
};

/* -------------------------------- 登陆 ------------------------------ */
// 发送登陆验证码
export var getMsgCode = function getMsgCode(params) {
  return request('get', '/api/crm/sec/web/getMsgCode', params);
};
// 登陆
export var login = function login(params) {
  return request('post', '/api/crm/sec/web/login', params);
};
// token信息更新
export var updateToken = function updateToken(params) {
  return request('post', '/api/crm/app/updateToken', params);
};
// 用户退出
export var userLogout = function userLogout(params) {
  return request('get', '/api/crm/sec/userLogout', params);
};
// 获取登录用户菜单权限
export var queryUserInfoByMobile = function queryUserInfoByMobile(mobile) {
  return request('get', "/api/crm/login/queryUserInfoByMobile/".concat(mobile));
};
// 登录二维码生成
export var loginQrCode = function loginQrCode(params) {
  return request('post', '/api/crm/sec/loginQrCode', params);
};
// 轮询二维码登录状态
export var querySweepCodeLoginStruts = function querySweepCodeLoginStruts(params) {
  return request('post', '/api/crm/sec/querySweepCodeLoginStruts', params);
};

/* -------------------------------- 订单模块 ------------------------------ */

// 去除订单某些字段的前后空格
var trimCreateOrder = function trimCreateOrder(params) {
  if (params.custName && typeof params.custName === 'string') {
    params.custName = params.custName.replace(/(^\s*)|(\s*$)/g, '');
  }
  return params;
};
// 创建订单
export var createOrder = function createOrder(params) {
  return request('post', '/api/crm/order/createOrder', trimCreateOrder(params));
};
// 组合套餐创建订单
export var createKfOrder = function createKfOrder(params) {
  return request('post', '/api/crm/order/createKfOrder', trimCreateOrder(params));
};
//  支付回调
export var notifyZf = function notifyZf(params) {
  return request('post', '/api/crm/order/notifyZf', params);
};
// 订单查询
export var queryCustomerOrder = function queryCustomerOrder(params) {
  return request('post', '/api/crm/order/queryCustomerOrder', params);
};
// 订单取消
export var cancelOrder = function cancelOrder(params) {
  return request('post', '/api/crm/order/cancelOrder/' + params);
};
// 查询用户复机后到期时间
export var queryExpireDate = function queryExpireDate(params) {
  return request('get', '/api/crm/order/expireDate', params);
};
// 查询单个订单
export var queryOneOrder = function queryOneOrder(orderId, params) {
  return request('get', '/api/crm/order/' + orderId, params);
};
// 根据订单编号查询订单
export var queryOrderContractNo = function queryOrderContractNo(orderContractNo) {
  return request('get', "/api/crm/order/info/".concat(orderContractNo));
};

/* -------------------------------- 资源管理 ------------------------------ */

// 查询资源终端轨迹信息
export var queryResOperOrderTerminalByPageApi = function queryResOperOrderTerminalByPageApi(params) {
  return request('post', '/api/crm/web/resOperOrderTerminal/queryResOperOrderTerminalByPage', params);
};
// 查询促销品信息
export var resMarketProduct = function resMarketProduct(params) {
  return request('get', '/api/crm/web/resMarketProduct/queryList', params);
};
// 获取宽带证号
export var resBroadNumOrigin = function resBroadNumOrigin(params) {
  return request('get', '/api/crm/web/resBroadNumOrigin/preemptionNum', params);
};
// 查询资源型号信息
export var searchResourceModel = function searchResourceModel(params) {
  return request('get', '/api/crm/web/resCode/query', params);
};
// 通过类型名称查询类型信息
export var queryListByResTypeName = function queryListByResTypeName(params) {
  return request('get', '/api/crm/web/resType/queryListByResTypeName', params);
};
// 根据ID查询资源大类
export var queryRestTypeList = function queryRestTypeList(params) {
  return request('get', '/api/crm/web/resType/queryList', params);
};
export var exportResType = function exportResType(params) {
  return request('img', '/api/crm/web/resType/exportResType', params);
};
// 新增资源类型
export var createResType = function createResType(params) {
  return request('post', '/api/crm/web/resType/createResType', params);
};
// 删除资源类型
export var deleteResType = function deleteResType(params) {
  return request('post', '/api/crm/web/resType/deleteResType/' + params);
};
// 启用资源类型
export var startResType = function startResType(params) {
  return request('post', '/api/crm/web/resType/startResType/' + params);
};
// 修改类型信息
export var updateResType = function updateResType(params) {
  return request('post', '/api/crm/web/resType/updateResType', params);
};
/* -------------------------------- 客户管理 ------------------------------ */
// 通过证件号码查询客户信息
export var searchUserInfo = function searchUserInfo(params) {
  return request('get', '/api/crm/web/Customers/query', params);
};
// 通过客户id查询客户信息
export var searchCustInfo = function searchCustInfo(param) {
  return request('get', '/api/crm/web/Customers/' + param);
};
/* -------------------------------- 地址信息 ------------------------------ */
// 查询地址信息
export var searchAddressInfo = function searchAddressInfo(params) {
  return request('get', '/api/crm/web/communities', params);
};
/* -------------------------------- 参数分组查询 ------------------------------ */
// 下拉框option
export var dropdownInfo = function dropdownInfo(params) {
  return request('get', '/api/crm/web/staticParam', params);
};
/* -------------------------------- 枚举类型查询 ------------------------------ */
// 枚举值
export var enums = function enums(params) {
  return request('get', '/api/crm/web/enum', params);
};
// 订单支付方式查询
export var queryPayType = function queryPayType(params) {
  return request('get', '/api/crm/web/enum/queryPayType', params);
};
// 选择订单支付方式查询
export var queryNewPayType = function queryNewPayType(params) {
  return request('get', '/api/crm/web/sys/queryPayType', params);
};
/* -------------------------------- 用户管理 ------------------------------ */
// 高级查询
export var advancedQuery = function advancedQuery(params) {
  return request('get', '/api/crm/web/insUser/query', params);
};
// 根据服务号码查询用户信息
export var serviceNumbers = function serviceNumbers(params) {
  if (params.billId) {
    return request('get', '/api/crm/web/insUser/queryByBillId', params);
  } else {
    Message({
      type: 'error',
      message: 'billId不可为空'
    });
    return Promise.reject('用户id为空');
  }
};
// 查询客户下的宽带用户
export var getBandWidthUsers = function getBandWidthUsers(params) {
  if (params.custId) {
    return request('get', '/api/crm/web/insUser/queryInsUserByCustId', params);
  } else {
    Message({
      message: 'custId不存在',
      type: 'error'
    });
    return Promise.reject('custId不存在');
  }
};
export var relUsersQuery = function relUsersQuery(params) {
  if (params.relUserId) {
    return request('get', '/api/crm/web/insUser/queryByRelUserId', params);
  } else {
    Message({
      message: 'relUserId不可为空',
      type: 'error'
    });
    return Promise.reject('relUserId为空');
  }
};
// 通过用户ID查询用户信息
export var getUserInfo = function getUserInfo(params) {
  if (params) {
    return request('get', '/api/crm/web/insUser/' + params);
  } else {
    Message({
      message: '用户id不可为空',
      type: 'error'
    });
    return Promise.reject('用户id为空');
  }
};
/* -------------------------------- 上传图片 ------------------------------ */
// 上传身份证
export var uploadIDCard = function uploadIDCard(formData, params) {
  return request('file', '/api/crm/web/file/upload?rtnStr=' + params, formData, 60 * 1000);
};
// 上传身份证确认信息
export var certPhotoSave = function certPhotoSave(params) {
  return request('post', '/api/crm/web/examine/certPhotoSave', params);
};
// 查询是否是已上传证件的老客户
export var confirmOldCus = function confirmOldCus(params) {
  return request('get', '/api/crm/web/examine/', params);
};
// 查询是否是已上传证件的老客户
export var confirmOldCusPage = function confirmOldCusPage(params) {
  return request('get', '/api/crm/web/examine/page', params);
};
// 获取文件
export var GetCard = function GetCard(fileId) {
  return request('img', '/api/crm/web/file/' + fileId);
};
// 身份证审核
export var examine = function examine(examineId, params) {
  return request('post', '/api/crm/web/examine/' + examineId, params);
};
// 身份证审核批量
export var batchExamine = function batchExamine(params) {
  return request('post', '/api/crm/web/examine/batchExamine', params);
};
/* -------------------------------- 支付模块 ------------------------------ */
// 创建离线支付请求，入参 {"outTradeNo":"xxxx"}
export var offLinePayRequest = function offLinePayRequest(params) {
  return request('post', '/api/crm/pay/offlinePayRequest', params);
};
// 离线完成支付
export var offLinePayBack = function offLinePayBack(params) {
  return request('post', '/api/crm/pay/offlinePayBack', params);
};
// 获取支付二维码图片
export var qrCodeImg = function qrCodeImg(params) {
  return request('img', '/api/crm/pay/qrCodeImg', params);
};
// 轮循查询订单支付状态
export var orderPayStatus = function orderPayStatus(params) {
  return request('get', '/api/crm/pay/orderPayStatus', params);
};
// 押金
export var deposits = function deposits(params) {
  // 无法传入sourceSystemId: 'WEB'
  return request('get', '/api/crm/web/deposits/' + params);
};
// 查询客户信息
export var Customers = function Customers(params) {
  return request('get', '/api/crm/web/Customers/' + params);
};
// 缴费明细查询
export var queryPaymentLogs = function queryPaymentLogs(params) {
  return request('get', '/api/crm/web/paymentLogs/', params);
};
// 短信链接支付
export var sendSmsPay = function sendSmsPay(params) {
  return request('post', '/api/crm/pay/sendSmsPay', params);
};

// 退押金
export var refund = function refund(params) {
  return request('post', '/api/crm/web/deposits/refund', params);
};
// 押金转收入
export var revenue = function revenue(params) {
  return request('post', '/api/crm/web/deposits/revenue', params);
};
/* -------------------------------- 账户资金变化查询 ------------------------------ */

// 账户资金变化查询
export var queryAccount = function queryAccount(params) {
  return request('get', '/api/crm/web/balances/logs', params);
};
/* -------------------------------- 权限管理 ------------------------------ */

// 用户状态权限判断
export var userStateAuth = function userStateAuth(params) {
  return request('get', '/api/crm/sec/menu/userStateAuth', params);
};
// 根据组织ID查询组织
export var queryOrgById = function queryOrgById(params) {
  return request('get', '/api/crm/sec/secorganize/' + params);
};
// 保存组织
export var saveOrg = function saveOrg(params) {
  return request('post', '/api/crm/sec/secorganize/saveOrg/', params);
};
// 查询下级组织
export var queryOrgByParent = function queryOrgByParent(params) {
  return request('get', '/api/crm/sec/secorganize/queryOrgByParent', params);
};
// 根据操作员code查询
export var operatorByCode = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(operatorCode) {
    var params, result, list;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            params = {
              state: '',
              ownOrgId: '',
              operatorName: '',
              operatorCode: operatorCode,
              mobile: '',
              limit: 1,
              curPage: 0
            };
            _context.next = 3;
            return operatorList(params);
          case 3:
            result = _context.sent;
            list = result.content.list || [];
            return _context.abrupt("return", list.length === 1 ? list[0] : {});
          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function operatorByCode(_x) {
    return _ref.apply(this, arguments);
  };
}();
// 操作员查询
export var operatorList = function operatorList(params) {
  return request('get', '/api/crm/sec/secoperator/queryList', params);
};
// 发展人查询
export var getDevperson = function getDevperson(params) {
  return request('get', '/api/crm/sec/secoperator/queryOpByRegionIdAndNameLike', params);
};
// 操作员新增
export var secoperatorSave = function secoperatorSave(params) {
  return request('post', '/api/crm/sec/secoperator/save', params);
};
// 操作员修改
export var secoperatorUpdate = function secoperatorUpdate(params) {
  return request('post', '/api/crm/sec/secoperator/update', params);
};
// 操作员删除
export var secoperatorDelete = function secoperatorDelete(params) {
  return request('get', '/api/crm/sec/secoperator/delete', params);
};
// 角色查询
export var secroleList = function secroleList(params) {
  return request('get', '/api/crm/sec/secrole/list', params);
};
// 角色新增
export var secroleSave = function secroleSave(params) {
  return request('post', '/api/crm/sec/secrole/save', params);
};
// 角色修改
export var secroleUpdate = function secroleUpdate(params) {
  return request('post', '/api/crm/sec/secrole/update', params);
};
// 角色删除
export var secroleDelete = function secroleDelete(params) {
  return request('get', '/api/crm/sec/secrole/delete', params);
};
// 查询工单角色
export var queryWorkerOrderTypeListApi = function queryWorkerOrderTypeListApi(params) {
  return request('get', '/api/crm/sec/secrole/queryWorkerOrderTypeList', params);
};
// 组织查询
export var secorganizeList = function secorganizeList(params) {
  return request('get', '/api/crm/sec/secorganize/list', params);
};
// 组织新增
export var secorganizeSave = function secorganizeSave(params) {
  return request('post', '/api/crm/sec/secorganize/save', params);
};
// 操作员城市查询
export var secOwnDistric = function secOwnDistric(params) {
  return request('get', '/api/crm/sys/queryOwnDistrict', params);
};
// 城市查询
export var queryOwnDistrict = function queryOwnDistrict(params) {
  return request('get', '/api/crm/sys/queryOwnDistrict', params);
};

// 组织修改
export var secorganizeUpadate = function secorganizeUpadate(params) {
  return request('post', '/api/crm/sec/secorganize/update', params);
};
// 组织状态更改
export var secorganizeUpadateStatus = function secorganizeUpadateStatus(params) {
  return request('get', '/api/crm/sec/secorganize/updateStatus', params);
};
// 查询组织树
export var queryTreeList = function queryTreeList(params) {
  return request('get', 'api/crm/sec/secorganize/queryTreeList', params);
};
// 查询组织树(包含服务站下挂的社区)
export var getOrgCommunity = function getOrgCommunity(params) {
  return request('get', 'api/crm/sec/secorganize/getOrgCommunity', params);
};
// 根据regionId查询组织树
export var queryCityOrganize = function queryCityOrganize(params) {
  return request('get', 'api/crm/sec/secorganize/queryCityOrganize', params);
};
// 查询地市树
export var queryDistrictTree = function queryDistrictTree(params) {
  return request('get', 'api/crm/queryDistrictTree/' + params);
};
// 查询地市
export var queryDistrictById = function queryDistrictById(params) {
  return request('get', 'api/crm/queryDistrictById/' + params);
};
// 未授权角色查询
export var queryNotOperatorRoleList = function queryNotOperatorRoleList(params) {
  return request('get', 'api/crm/sec/secrole/queryNotOperatorRoleList', params);
};
// 已授权角色查询
export var queryOperatorRoleList = function queryOperatorRoleList(params) {
  return request('get', 'api/crm/sec/secrole/queryOperatorRoleList', params);
};
// 操作员分配角色
export var saveOperatorOrRole = function saveOperatorOrRole(params) {
  return request('post', 'api/crm/sec/secrole/saveOperatorOrRole', params);
};
// 组织切换列表查询
export var queryOperatorOrOrgList = function queryOperatorOrOrgList(params) {
  return request('get', 'api/crm/sec/secorganize/queryOperatorOrOrgList', params);
};
// 组织切换
export var operatorOrganizationChange = function operatorOrganizationChange(params) {
  return request('get', 'api/crm/sec/secorganize/operatorOrganizationChange', params);
};
// 设置默认组织
export var setDefaultOrg = function setDefaultOrg(params) {
  return request('post', 'api/crm/sec/secorganize/setDefaultOrg', params);
};
// 离开组织
export var leaveOrg = function leaveOrg(params, body) {
  return request('delete', 'api/crm/sec/secorganize/leaveOrg', params, 10 * 1000, body);
};
// 进行组织关联
export var saveOperatorOrOrganize = function saveOperatorOrOrganize(params) {
  return request('post', 'api/crm/sec/secorganize/saveOperatorOrOrganize', params);
};
// 查询下级组织,如果当前组织类型为服务站，则返回本身组织
export var queryServiceStation = function queryServiceStation(params) {
  return request('get', 'api/crm/sec/secorganize/queryServiceStation', params);
};

/* ------------------------------查询AAA 相关信息---------------------*/
export var queryOnlineInfo = function queryOnlineInfo(params) {
  return request('get', '/api/crm/web/radiusQuery/queryOnlineInfo', params);
};
// 认证日志查询
export var queryAccessLog = function queryAccessLog(params) {
  return request('get', '/api/crm/web/radiusQuery/queryAccessLog', params);
};
// 在线IP查询
export var queryOnlineInfoByUserIP = function queryOnlineInfoByUserIP(params) {
  return request('get', '/api/crm/web/radiusQuery/queryOnlineInfoByUserIP', params);
};

/* -------------------------------- 系统默认参数 ------------------------------ */

// 设置公告
export var noticeSave = function noticeSave(params) {
  return request('post', '/api/crm/sys/notice/save', params);
};
// 查询公告
export var noticeQuery = function noticeQuery(params) {
  return request('get', '/api/crm/sys/notice/query', params);
};

// @modified: lifei
// @date: 2020-04-29
// @description: 绑定vlan查询
export var queryVlanBindInfo = function queryVlanBindInfo(params) {
  return request('post', '/api/crm/web/vlanBind/queryVlanBindInfo', params);
};
// 按列表进行解绑
export var vlanUnbindBySelection = function vlanUnbindBySelection(params) {
  return request('post', 'api/crm/web/vlanBind/bindUserVlanByForm', params);
};
// 按条件解绑
export var batchUnbindVlan = function batchUnbindVlan(params) {
  return request('post', 'api/crm/web/vlanBind/batchUnbindVlan', params);
};

// @modified: jilongbo
// @date: 2020-05-15
// @description: 查询宽带详单
export var queryUsageNatList = function queryUsageNatList(params) {
  return request('post', '/api/crm/web/aaa/queryUsageNatList', params);
};

// 根据归属组织和归属社区查询操作员状态
export var queryOperatorList = function queryOperatorList(params) {
  return request('get', '/api/crm/sec/secoperator/queryOperatorList', params);
};
// 根据操作员code查详情
export var queryOperator = function queryOperator(params) {
  return request('get', '/api/crm/sec/secoperator/queryOperatorByCode', params);
};
// 通过操作员编码分页模糊查询在用操作员列表
export var queryOperatorListApi = function queryOperatorListApi(params) {
  return request('get', '/api/crm/sec/secoperator/queryOperatorPageByLikeCode', params);
};
// 通过操作员ID查询操作员和社区关系信息
export var queryCommunityByOpId = function queryCommunityByOpId(params) {
  return request('get', '/api/crm/sec/secoperator/queryCommunityByOpId', params);
};
// 通过操作员ID查询操作员和社区关系信息
export var updateOpCommunityRel = function updateOpCommunityRel(params) {
  return request('post', '/api/crm/sec/secoperator/updateOpCommunityRel', params);
};
export var queryOpSchedule = function queryOpSchedule(params) {
  return request('get', '/api/crm/sec/secoperator/opSchedule', params);
};
export var upDateOpSchedule = function upDateOpSchedule(params) {
  return request('post', '/api/crm/sec/secoperator/daySchedule', params);
};

/* -------------------------------- ------------------------------ */
/*
作者：陈娜
作用：资源设备信息管理--获得终端状态下拉框  params为{ codeType: 'RES_TERMINAL_STATE' }
接口平台名称： 系统默认参数——根据参数分组查询一组参数
 */
export var getParams = function getParams(params) {
  return request('get', '/api/crm/web/staticParam', params);
};

/*
作者：刘瑞玲
作用： 获得用户预约订单时间
接口平台名称：查询用户预约信息
 */
export var getBookingData = function getBookingData(params) {
  return request('get', '/api/crm/order/bookings', params);
};

/*
作用：报表接口
 */
/* -----------------------------报表查询条件查询--------------------------------- */
export var getReportSearch = function getReportSearch(params) {
  return request('get', "".concat(rptApi, "/rptQueryPara"), params);
};

/* -----------------------------报表展示数据查询--------------------------------- */
export var getReportDatas = function getReportDatas(params) {
  return request('post', "".concat(rptApi, "/rptQueryData"), params);
};

/* -----------------------------报表查询条件下拉框组件展示数据查询--------------------------------- */
export var getReportSelectDatas = function getReportSelectDatas(url, params) {
  return request('get', url, params);
};
/* -----------------------------报表导出EXCEL--------------------------------- */
export var getReportExcel = function getReportExcel(params) {
  var config = {
    url: "".concat(rptApi, "/rptExportExcel"),
    data: params
  };
  return downloadPost(config);
};
export var downloadPost = function downloadPost(config) {
  var headers = {
    Authorization: "Bearer ".concat(localStorage.getItem('token')),
    responseType: 'blob'
  };
  return axios({
    url: config.url,
    method: 'post',
    headers: headers,
    responseType: 'blob',
    data: config.data
  });
};
/*
作者：陈娜
作用： 余额查询
接口平台名称：预存款管理——余额查询
 */
export var getBalance = function getBalance(params) {
  return request('get', '/api/crm/web/balances', params);
};
// 查询用户某种费用的余额
export var getFeeBalance = function getFeeBalance(params) {
  return request('get', '/api/crm/web/balances/feeTypeBalance', params);
};
/* -------------------------------- ------------------------------ */
/*
作者：陈娜
作用： 费用大类、退费原因
接口平台名称：系统默认参数——根据参数分组查询一组参数
 */
/**
 * 费用大类参数：FEE_TYPE_KIND
 * 退费原因参数：REFUND_REASON
 */
export var getDropDownBoxVal = function getDropDownBoxVal(params) {
  return request('get', '/api/crm/web/staticParam', params);
};
/* --------------------------------  ------------------------------ */
/*
作者：陈娜
作用： 费用类型
接口平台名称：预存款管理——余额查询
 */
export var getCostType = function getCostType(params) {
  return request('get', '/api/crm/web/ams/config/feeTypes', params);
};
// 获取费用类型
export var staticParams = function staticParams(params) {
  return request('get', '/api/crm/web/staticParam', params);
};
/* --------------------------------  ------------------------------ */
/*
作者：陈娜
作用： 退费方式
接口平台名称：系统默认参数——根据枚举类型查询枚举值
 */
export var getRefundWay = function getRefundWay(params) {
  return request('get', '/api/crm/web/enum', params);
};
/* -------------------------------- ------------------------------ */
/*
作者：陈娜
作用： 退费提交按钮
接口平台名称：预存款管理——退费
 */
export var getRefundSubmit = function getRefundSubmit(params) {
  return request('post', '/api/crm/web/balances/refund', params);
};
/* -------------------------------- ------------------------------ */
/*
作者：陈娜
作用： 转收入提交按钮
接口平台名称：预存款管理——转收入
 */
export var getIncomeSubmit = function getIncomeSubmit(params) {
  return request('post', '/api/crm/web/balances/revenue', params);
};

/**
 * 资源管理页面接口
 * 陈娜
 */

/* --------------------------------  ------------------------------ */
/*
作者：陈娜
作用：新增设备型号(包括促销品)
接口平台名称：资源管理——新增设备型号
 */
export var addModel = function addModel(params) {
  return request('post', '/api/crm/web/resCode/createTerminalResCode', params);
};
/* -------------------------------------------------------------- */
/*
作者：陈娜
作用： 资源大类组织树数据
接口平台名称：资源管理——查询父节点下的类型信息
 */
export var getNode = function getNode(params) {
  return request('get', '/api/crm/web/resType/queryList', params);
};
/* -------------------------------- ------------------------------ */
/*
作者：陈娜
作用： 批量新增设备信息
接口平台名称：资源管理——终端批量入库
 */
export var batchAdd = function batchAdd(params) {
  return request('file', '/api/crm/web/resTerminalOrigin/uploadFile', params);
};
/* -------------------------------- ------------------------------ */
/*
作者：陈娜
作用：通过城市、资源大类、设备型号查询促销品
接口平台名称：资源管理——通过型号名称模糊查询资源型号信息
 */
export var getList = function getList(params) {
  return request('get', '/api/crm/web/resMarketProduct/query', params);
};

/*
作者：刘瑞玲
作用：通过城市、资源大类、设备型号查询资源信息
接口平台名称：资源管理——通过型号名称模糊查询资源型号信息
 */
export var getResCodeInfos = function getResCodeInfos(params) {
  return request('get', '/api/crm/web/resCode/queryList', params);
};
/*
作者：陈娜
作用：通过城市、资源大类、设备型号查询资源列表（通过型号名称模糊查询资源型号信息 ）包括促销品
接口平台名称：资源管理——通过型号名称模糊查询资源型号信息
 */
export var queryList = function queryList(params) {
  return request('get', '/api/crm/web/resCode/queryList', params);
};
/* --------------------------------  ------------------------------ */
/*
作者：陈娜
作用：修改设备型号
接口平台名称：资源管理——修改型号信息
 */
export var changeModel = function changeModel(params) {
  return request('post', '/api/crm/web/resCode/updateTerminalResCode', params);
};
/* --------------------------------  ------------------------------ */
/*
作者：陈娜
作用：删除设备型号(包括促销品)
接口平台名称：资源管理--删除型号信息
 */
export var delModel = function delModel(params) {
  return request('post', '/api/crm/web/resCode/deleteTerminalResCode', qs.stringify(params));
};
/* --------------------------------  ------------------------------ */
/*
作者：陈娜
作用：单个新增设备型号
接口平台名称：资源管理--终端入库
 */
export var singleAddModel = function singleAddModel(params) {
  return request('post', '/api/crm/web/resTerminalOrigin/createResTerminalOrigin', params);
};
/* --------------------------------  ------------------------------ */
/*
作者：陈娜
作用：资源设备信息管理--查询资源查询修改
接口平台名称：资源管理--通过序列号和MAC分页查询设备未用表信息
 */
export var searchModelInfo = function searchModelInfo(params) {
  return request('get', '/api/crm/web/resTerminalOrigin/queryPage', params);
};
// 通过型号和序列号查询设备未用表信息
export var queryOneTerminalOrigin = function queryOneTerminalOrigin(params) {
  return request('get', '/api/crm/web/resTerminalOrigin/queryOneTerminalOrigin', params);
};
/* -------------------------------- ------------------------------ */
/*
作者：陈娜
作用： 删除单个资源设备信息
接口平台名称：资源管理--删除设备未用表信息
 */
export var delModelInfo = function delModelInfo(params) {
  return request('post', '/api/crm/web/resTerminalOrigin/deleteResTerminalOrigin', qs.stringify(params));
};
/* -------------------------------- ------------------------------ */
/**
 * 作者：陈娜
 * 作用： 资源设备信息管理——修改资源信息  调用此接口
 * 接口平台名称：资源管理--修改设备信息
 */
export var modifyModelInfo = function modifyModelInfo(params) {
  return request('post', '/api/crm/web/resTerminalOrigin/updateResTerminalOrigin', params);
};
/* -------------------------------- ------------------------------ */
/**
 * 作者：籍龙波
 * 作用： 资源设备信息管理——导出excel  调用此接口
 * 接口平台名称：资源管理--导出
 */
export var exportResTerminalOrigin = function exportResTerminalOrigin(params) {
  return request('img', '/api/crm/web/resTerminalOrigin/exportResTerminalOrigin', params);
};

/*
  作者：陈娜
作用：请求服务站
接口平台名称：权限管理模块——组织列表查询，此接口可能会相应很慢，慎重使用
  * /
export const getServiceStation = (params) => {
  return request('get', '/api/crm/sec/secorganize/list', params);
};
/*
根据名字查询组织，返回前10条
 */
export var queryOrgListByName = function queryOrgListByName(params) {
  return request('get', '/api/crm/sec/secorganize/queryOrgListByName', params);
};
/* --------------------------------  ------------------------------ */
/*
作者：陈娜
作用：新增社区
接口平台名称：系统默认参数——社区管理信息新增
 */
export var createCommunity = function createCommunity(params) {
  return request('post', '/api/crm/sys/saveCommunity', params);
};
/* -------------------------------- ------------------------------ */
/*
作者：陈娜
作用： 社区管理列表查询
接口平台名称：系统默认参数——社区管理列表查询
 */
export var getCommunityList = function getCommunityList(params) {
  return request('get', '/api/crm/sys/queryCommunityList', params);
};
/* -------------------------------- ------------------------------ */
/*
作者：陈娜
作用： 单个修改社区
接口平台名称：系统默认参数——社区管理信息修改
 */
export var modifyCommunity = function modifyCommunity(params) {
  return request('post', '/api/crm/sys/updateCommunity', params);
};
/* --------------------------------  ------------------------------ */
/*
作者：陈娜
作用：单个删除社区，删除前会判断被删社区是否存在用户
接口平台名称：系统默认参数——社区管理信息删除
 */
export var delCommunity = function delCommunity(params) {
  return request('get', '/api/crm/sys/deleteCommunity', params);
};
/* --------------------------------  ------------------------------ */
/*
作者：陈娜
作用：社区服务站批量修改
接口平台名称：系统默认参数——社区服务站批量修改
 */
export var bulkChangesCommunity = function bulkChangesCommunity(params) {
  return request('post', '/api/crm/sys/updateCommunityServiceStation', params);
};
/**
 * 根据组织id查询以下所有社区
 * @param params
 * @returns {AxiosPromise<any> | AxiosPromise}
 */
export var queryCommunityByOrgId = function queryCommunityByOrgId(params) {
  return request('get', '/api/crm/sys/queryCommunityByOrgId', params);
};
/*
作者：陈娜
作用：月账单查询
接口平台名称：账单管理——账单查询
 */
export var getMonthlyBills = function getMonthlyBills(params) {
  return request('get', '/api/crm/web/bills', params);
};

/* --------------------------------  ------------------------------ */
/*
作者：陈娜
作用：周期性和一次性的费用类型
接口平台名称：系统默认参数——根据参数分组查询一组参数
 */
export var getSpecifiedCostType = function getSpecifiedCostType() {
  return request('get', '/api/crm/web/ams/config/specifiedFeeTypes', null);
};

/* -------------------------------------------------------------- */
/*
作者：陈娜
作用：调账转预存
接口平台名称：账单管理——账单查询
 */
export var getAdjustToBalanceSubmit = function getAdjustToBalanceSubmit(params) {
  return request('post', '/api/crm/web/bills/balance', params);
};

/* ------------------------------调账补偿性退费-------------------------------- */
export var getAdjustToRefundSubmit = function getAdjustToRefundSubmit(params) {
  return request('post', '/api/crm/web/bills/refund', params);
};

/* -----------------------------调账提交按钮--------------------------------- */
export var getAdjustSubmit = function getAdjustSubmit(params, isBalanceSubmit, payWay) {
  if (isBalanceSubmit) {
    return getAdjustToBalanceSubmit(params);
  } else {
    params.payType = payWay;
    return getAdjustToRefundSubmit(params);
  }
};
/* -------------------------------- 长鸿二期 - 刘松 ------------------------------ */

// 查询客户列表
export var queryKfCust = function queryKfCust(params) {
  return request('get', '/api/crm/web/Customers/queryKfCust', params);
};
// 根据客户id查询客户详情
export var queryCustomersInfo = function queryCustomersInfo(params) {
  return request('get', "/api/crm/web/insUser/queryUserByCustId", params);
};
// 根据客户id与billId查询客户详情
export var queryCustomersInfoByBillId = function queryCustomersInfoByBillId(params) {
  return request('get', "/api/crm/web/insUser/queryUserByCustIdAndBillId", params);
};
// 查询用户全部订单
export var queryAllOrderByUserId = function queryAllOrderByUserId(params) {
  return request('post', "/api/crm/order/queryAllOrderByUserId", params);
};
// 查询用户全部订单
export var queryCommunityTree = function queryCommunityTree(regionId) {
  return request('get', "/api/crm/sec/secorganize/queryCommunityTree/".concat(regionId));
};
// 根据组织查人员
export var queryOpByOrgId = function queryOpByOrgId(query) {
  return request('get', "/api/crm/sec/secoperator/queryOpByOrgId", query);
};
// 通过城市和角色类型查询员工
export var queryOpByRegionIdAndRole = function queryOpByRegionIdAndRole(query) {
  return request('get', "/api/crm/sec/secoperator/queryOpByRegionIdAndRole", query);
};
// 根据组织查人员--入参有BODY的roleCode
export var queryOpByOrgIdBody = function queryOpByOrgIdBody(query, body) {
  return request('getbody', "/api/crm/sec/secoperator/queryOpByOrgId", query, body);
};
// 查询操作员所在所有该城市下该组织类型下的所有该角色的员工
export var queryChildOpByOrgTypeAndRole = function queryChildOpByOrgTypeAndRole(query) {
  return request('get', '/api/crm/sec/secoperator/queryChildOpByOrgTypeAndRole', query);
};

// 潜户录入
export var createPotential = function createPotential(params) {
  return request('post', '/api/crm/web/potential/createPotential', params);
};
// 潜户列表查询
export var queryPotentiall = function queryPotentiall(params) {
  return request('post', '/api/crm/web/potential/queryPotential', params);
};
// 批量导入修改用户标签信息
export var queryUserMarkHPage = function queryUserMarkHPage(params) {
  return request('post', '/api/crm/order/queryUserMarkHPage', params);
};
// 批量导入修改用户标签信息
export var queryUserMarkPage = function queryUserMarkPage(params) {
  return request('post', '/api//crm/order/queryUserMarkPage', params);
};
// 批量导入修改用户标签信息
export var updateUserMarkList = function updateUserMarkList(params) {
  return request('post', '/api/crm/order/updateUserMarkList', params);
};
// 社区地址查询
export var queryCommunityList = function queryCommunityList(params) {
  return request('get', '/api/crm/sys/queryCommunityList', params);
};
// 社区地址查询
export var queryCommunityListNew = function queryCommunityListNew(params) {
  return request('get', '/api/crm/sys/queryCommunityListNew', params);
};
// 查询是否有在途订单
export var queryUnfinishedOrders = function queryUnfinishedOrders(params, pagePath) {
  var queryUnfinishedOrders = function queryUnfinishedOrders() {
    return request('get', '/api/crm/order/orderUnfinished', params);
  };
  return requestPro(queryUnfinishedOrders, {
    uniqueConf: {
      pagePath: pagePath
    }
  });
};
// 解绑vlan
export var unbindUserVlan = function unbindUserVlan(params) {
  return request('post', '/api/crm/web/radius/unbindUserVlan', params);
};
export var queryByBmsUserName = function queryByBmsUserName(params) {
  return request('get', '/api/crm/web/vlanBind/queryByBmsUserName', params);
};
// 清理在线信息
export var clearOnlineInfo = function clearOnlineInfo(params) {
  return request('post', '/api/crm/web/radius/delOnlineUserInfo', params);
};
// 查询审核订单
export var queryOrderByPage = function queryOrderByPage(params) {
  return request('post', '/api/crm/order/queryOrderByPage', params);
};
// 查询审核日志
export var queryExamineLog = function queryExamineLog(params) {
  return request('get', "/api/crm/order/queryExamineLog/".concat(params));
};
// 记录审核记录
export var createExamineLog = function createExamineLog(params) {
  return request('post', "/api/crm/order/createExamineLog", params);
};
// 根据订单号查询订单
export var queryOrder = function queryOrder(params, customerOrderId) {
  return request('get', "/api/crm/order/".concat(customerOrderId), params);
};
// 根据订单号查询审核订单
export var examineOrderIds = function examineOrderIds(params) {
  var currentPath = store.getters.getCurrentPath;
  var examineOrderIds = function examineOrderIds() {
    return request('get', "/api/crm/order/examineOrderIds", params);
  };
  return requestPro(examineOrderIds, {
    uniqueConf: {
      currentPath: currentPath
    }
  });
};
// 根据订单号查询支付凭证
export var payProof = function payProof(params) {
  return request('img', "/api/crm/order/payProof/".concat(params.customerOrderId), params);
};
// 导出社区信息
export var exportCommunityList = function exportCommunityList(params) {
  return request('img', "/api/crm/sys/exportCommunityList", params);
};
/* -------------------------------- 获取原来的客户 ------------------------------ */
export var queryOldCustomerInto = function queryOldCustomerInto(custId) {
  return request('get', "/api/crm/web/Customers/".concat(custId));
};
/* -------------------------------- 查询预约单 ------------------------------ */
export var queryBookingOrder = function queryBookingOrder(params) {
  return request('get', '/api/crm/order/bookings', params);
};
/* --------------------------------  ------------------------------ */
export var queryCommunityById = function queryCommunityById(communityId) {
  return request('get', "/api/crm/sys/queryCommunityById/".concat(communityId));
};
export var queryProvinceDistrictByRegionIdApi = function queryProvinceDistrictByRegionIdApi(regionId) {
  return request('get', "/api/crm/sys/queryProvinceDistrictByRegionId/".concat(regionId));
};
// 通过套餐实例id查询属性实例值
export var insAttr = function insAttr(params) {
  return request('get', '/api/crm/web/insAttr/' + params);
};
// 通过属性编码查询服务数据信息
export var queryAttrByAttrCode = function queryAttrByAttrCode(query) {
  return request('get', '/api/crm/web/offers/queryAttrByAttrCode', query);
};

// 查询已用设备列表信息
export var queryResTerminalUsedByPage = function queryResTerminalUsedByPage(params) {
  return request('post', '/api/crm/web/resTerminalUsed/queryResTerminalUsedByPage', params);
};
// 查询裸机销售后已用设备信息
export var queryResTerminalUsed = function queryResTerminalUsed(params) {
  return request('get', '/api/crm/web/resTerminalUsed/queryResTerminalUsed', params);
};
// 单个设备退订
export var rollbackTerminal = function rollbackTerminal(resId, params) {
  return request('post', "/api/crm/web/resTerminalUsed/rollbackTerminal/".concat(resId), qs.stringify(params));
};
// 行政区接口#根据regionId地市查询
export var queryDistrictByRegionId = function queryDistrictByRegionId(regionId) {
  return request('get', "/api/crm/queryDistrictByRegionId/".concat(regionId));
};
// 通过查询条件导出操作员与社区信息
export var exportQueryOperatorList = function exportQueryOperatorList(params) {
  return request('img', "/api/crm/sec/secoperator/exportQueryOperatorList", params);
};
// 分页查询一区一策信息
export var queryOfferCommunity = function queryOfferCommunity(params) {
  return request('post', "/api/crm/web/offers/queryOfferCommunity", params);
};
// 添加一区一策配置
export var saveOfferCommunity = function saveOfferCommunity(params) {
  return request('post', "/api/crm/web/offers/saveOfferCommunity", params);
};
// 通过套餐id查询已配置的社区信息列表
export var queryOfferCommunityByOfferId = function queryOfferCommunityByOfferId(params) {
  return request('get', "/api/crm/web/offers/queryOfferCommunityByOfferId", params);
};
// 导出条件对应的一人一策信息
export var exportOfferOperator = function exportOfferOperator(params) {
  return request('img', "/api/crm/web/offers/exportOfferOperator", params);
};
// 导出条件对应的一区一策信息
export var exportOfferCommunity = function exportOfferCommunity(_ref2) {
  var regionId = _ref2.regionId,
    communityId = _ref2.communityId,
    offerId = _ref2.offerId,
    offerName = _ref2.offerName;
  return request('img', "/api/crm/web/offers/exportOfferCommunity", {
    regionId: regionId,
    communityId: communityId,
    offerId: offerId,
    offerName: offerName
  });
};
// 分页查询一人一策信息
export var queryOfferOperator = function queryOfferOperator(params) {
  return request('post', "/api/crm/web/offers/queryOfferOperator", params);
};
// 通过套餐id查询已配置的人员信息列表
export var queryOfferOperatorByOfferId = function queryOfferOperatorByOfferId(params) {
  return request('get', "/api/crm/web/offers/queryOfferOperatorByOfferId", params);
};
// 配置一人一策信息
export var saveOfferOperator = function saveOfferOperator(_ref3) {
  var offerId = _ref3.offerId,
    operatorIds = _ref3.operatorIds;
  return request('post', "/api/crm/web/offers/saveOfferOperator", {
    offerId: offerId,
    operatorIds: operatorIds
  });
};
// 根据套餐查询未配置的人员
export var queryNotOfferOperatorByOfferId = function queryNotOfferOperatorByOfferId(_ref4) {
  var offerId = _ref4.offerId,
    regionId = _ref4.regionId;
  return request('get', "/api/crm/web/offers/queryNotOfferOperatorByOfferId", {
    offerId: offerId,
    regionId: regionId
  });
};
// 查询套餐未配置的社区
export var queryNotOfferCommunityByOfferId = function queryNotOfferCommunityByOfferId(_ref5) {
  var offerId = _ref5.offerId,
    regionId = _ref5.regionId;
  return request('get', "/api/crm/web/offers/queryNotOfferCommunityByOfferId", {
    offerId: offerId,
    regionId: regionId
  });
};

// 通过手机号码和归属区域查询操作员信息
export var queryOperatorByMobile = function queryOperatorByMobile(params) {
  return request('get', "/api/crm/sec/secoperator/queryOperatorByMobile", params);
};

//
export var queryServiceStationByRegionId = function queryServiceStationByRegionId(regionId) {
  return request('get', "/api/crm/sec/secorganize/queryServiceStationByRegionId/".concat(regionId));
};

// 根据组织ID查询所有下级组织的员工列表
export var queryAllOperatorByOrgIdApi = function queryAllOperatorByOrgIdApi(orgId) {
  return request('get', "/api/crm/sec/secoperator/queryAllOperatorByOrgId/".concat(orgId));
};
// 根据组织ID查询所有下级组织的社区列表
export var queryAllCommunityByOrgIdApi = function queryAllCommunityByOrgIdApi(orgId) {
  return request('get', "/api/crm/sec/secorganize/queryAllCommunityByOrgId/".concat(orgId));
};
// 分页查询用户订单信息
export var queryOrderUserByConditionApi = function queryOrderUserByConditionApi(params) {
  return request('post', "/api/crm/order/queryOrderUserByCondition", params);
};
// 根据查询用户订单信息的查询条件创建业务单
export var createBusinessByQueryOrdUserCondition = function createBusinessByQueryOrdUserCondition(params) {
  return request('post', "/api/crm/web/BusinessOrder/createBusinessByQueryOrdUserCondition", params);
};
// 创建业务单
export var createBusinessOrderApi = function createBusinessOrderApi(params) {
  return request('post', "/api/crm/web/BusinessOrder", params);
};
// 通过条件分页查询用户信息
export var queryUserByConditionApi = function queryUserByConditionApi(params) {
  return request('get', "/api/crm/web/insUser/queryUserByCondition", params);
};
// 通过关联用户编号和租户查询所有被关联的用户用户信息
export var queryByRelUserIdAndTenantApi = function queryByRelUserIdAndTenantApi(params) {
  if (params.relUserId) {
    return request('get', "/api/crm/web/insUser/queryByRelUserIdAndTenant", params);
  } else {
    Message({
      type: 'error',
      message: 'relUserId不可为空'
    });
    return Promise.reject('relUserId为空');
  }
};
// 根据查询用户信息的查询条件创建业务单
export var createBusinessByQueryUserConditionApi = function createBusinessByQueryUserConditionApi(params) {
  return request('post', "/api/crm/web/BusinessOrder/createBusinessByQueryUserCondition", params);
};
// 通过条件查询收购信息
export var queryBusinessOrderByConditionApi = function queryBusinessOrderByConditionApi(params) {
  return request('get', "/api/crm/web/BusinessOrder/queryBusinessOrderByCondition", params);
};

// 通过条件查询收购信息
export var orderClaimAndCompleteTaskApi = function orderClaimAndCompleteTaskApi(taskId, params) {
  var currentPath = store.getters.getCurrentPath;
  var orderClaimAndCompleteTaskApi = function orderClaimAndCompleteTaskApi() {
    return request('post', "/api/crm/order/claimAndCompleteTask/".concat(taskId), params);
  };
  return requestPro(orderClaimAndCompleteTaskApi, {
    uniqueConf: {
      currentPath: currentPath
    },
    debounceTime: 3000
  });
};

// 查询操作员品牌信息
export var operatorOrBrandApi = function operatorOrBrandApi(params) {
  return request('post', "/api/crm/sec/secoperator/opBrandRel/".concat(params.operatorId), params);
};

// 操作员分配品牌
export var operatorDispatchBrandApi = function operatorDispatchBrandApi(params) {
  return request('post', "/api/crm/sec/secoperator/saveOpBrandRel", params);
};
/**
 * 根据dimensionCode和orgId查询纬度值
 *
 */
export var queryDimensionValueByOrder = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dimensionCode, org) {
    var orgId, regionId, temp, _temp, _temp2;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            orgId = org.orgId, regionId = org.regionId;
            if (!(dimensionCode === '4')) {
              _context2.next = 9;
              break;
            }
            _context2.next = 4;
            return queryAllOperatorByOrgIdApi(orgId);
          case 4:
            temp = _context2.sent;
            temp.content.forEach(function (ele) {
              ele['dimensionId'] = dimensionCode;
              ele['id'] = ele.operatorCode;
              ele['name'] = ele.operatorName;
            });
            return _context2.abrupt("return", temp);
          case 9:
            if (!(dimensionCode === '5')) {
              _context2.next = 17;
              break;
            }
            _context2.next = 12;
            return queryServiceStationByRegionId(regionId);
          case 12:
            _temp = _context2.sent;
            _temp.content.forEach(function (ele) {
              ele['dimensionId'] = dimensionCode;
              ele['id'] = ele.orgId;
              ele['name'] = ele.orgName;
            });
            return _context2.abrupt("return", _temp);
          case 17:
            _context2.next = 19;
            return queryAllCommunityByOrgIdApi(orgId);
          case 19:
            _temp2 = _context2.sent;
            _temp2.content.forEach(function (ele) {
              ele['dimensionId'] = dimensionCode;
              ele['id'] = ele.communityId;
              ele['name'] = ele.communityName;
            });
            return _context2.abrupt("return", _temp2);
          case 22:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function queryDimensionValueByOrder(_x2, _x3) {
    return _ref6.apply(this, arguments);
  };
}();